export default __webpack_public_path__ + "static/media/Q16_3_resized.092987dc.jpg";